import clsx from "clsx";
import { isUndefined } from "lodash-es";
import { useState } from "react";

import type { FragmentType } from "~/utils/fragment";

import { ImageCaption } from "../ImageCaption";
import type { ImageClue_DefinitionFragment } from "./ImageClue_DefinitionFragment";

export const ImageClue: React.FC<{
  definition: FragmentType<
    "Definition",
    { select: typeof ImageClue_DefinitionFragment }
  >;
}> = ({ definition }) => {
  const [aspectRatio, setAspectRatio] = useState<number>();

  if (!definition.image) {
    return null;
  }

  return (
    <div className="absolute inset-0 grid auto-cols-fr grid-flow-col gap-4 p-4">
      <div className="relative">
        <div className="absolute inset-0 flex">
          <div
            className={clsx(
              "relative m-auto max-h-full max-w-full transition-opacity",
              isUndefined(aspectRatio) && "opacity-0",
            )}
            style={{ aspectRatio }}
          >
            <img
              draggable={false}
              className="size-full object-contain"
              alt={definition.text}
              src={definition.image}
              onLoad={(event) => {
                const { naturalWidth, naturalHeight } = event.currentTarget;
                setAspectRatio(naturalWidth / naturalHeight);
              }}
            />
            {definition.text && !definition.sbs && (
              <ImageCaption className="w-full">{definition.text}</ImageCaption>
            )}
          </div>
        </div>
      </div>
      {definition.sbs && (
        <div className="flex items-center justify-center">
          {definition.text}
        </div>
      )}
    </div>
  );
};
